'use client';

import Link from 'next/link';
import { createContext, useContext, type ReactNode } from 'react';

export type NotFoundCopy = {
  message: string;
  returnHome: string;
};

const NotFoundCopyContext = createContext<NotFoundCopy | null>(null);

export function NotFoundCopyProvider({
  copy,
  children
}: {
  copy: NotFoundCopy;
  children: ReactNode;
}) {
  return <NotFoundCopyContext.Provider value={copy}>{children}</NotFoundCopyContext.Provider>;
}

function useNotFoundCopy() {
  const copy = useContext(NotFoundCopyContext);
  if (!copy) {
    throw new Error('useNotFoundCopy must be used within a NotFoundCopyProvider');
  }
  return copy;
}

export function NotFoundBody() {
  const copy = useNotFoundCopy();
  return (
    <div className="mx-auto w-full max-w-4xl px-5 py-24 text-center">
      <h1 className="font-rowdies mb-3 text-3xl font-bold uppercase text-mv-white md:text-5xl">
        404
      </h1>
      <p className="mb-8 text-mv-white/60">{copy.message}</p>
      <Link
        prefetch={false}
        href="/"
        className="rounded-full bg-mv-primary px-7 py-3 font-semibold text-black transition-opacity hover:opacity-90"
      >
        {copy.returnHome}
      </Link>
    </div>
  );
}
